/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>


module Meevo.Plugins.YieldManagementProgram {
    export interface IProgramTimeRange {
        dayOfWeek?: number;
        startTime?: Date|string;
        endTime?: Date|string;
        programAdjustmentOverride?: ProgramAdjustmentOverrideEnum;
        adjustment?: number;
        locationId?: number;
        valid?: boolean;
        isNew?: boolean;
    }

    export class ProgramTimeRange implements IProgramTimeRange {
        locationId?: number;
        dayOfWeek?: number;
        startTime?: Date|string;
        endTime?: Date|string;
        programAdjustmentOverride?: ProgramAdjustmentOverrideEnum;
        adjustment?: number;
        valid?: boolean;
        isNew?: boolean = false;

        get hasLocationId(): boolean {
            return Model.Guard.isSomething(this.locationId);
        }

        constructor(itemRange: IProgramTimeRange = {}) {
            Object.assign(this, itemRange);

            this.validate([]);
        }

        validate(timeRanges: ProgramTimeRange[]) {
            this.valid = true;

            if (this.adjustment === 0) { // do not allow zero adjustment
                this.valid = false;

                return;
            } else if (this.startTime >= this.endTime) { // end time has to be higher
                this.valid = false;

                return;
            }

            for (const timeRange of timeRanges) {
                if (timeRange === this) continue;

                // time ranges should not overlap
                const timeRangeStartTime = parseInt(moment(timeRange.startTime).format('HHmm'));
                const timeRangeEndTime = parseInt(moment(timeRange.endTime).format('HHmm'));
                const thisStartTime = parseInt(moment(this.startTime).format('HHmm'));
                const thisEndTime = parseInt(moment(this.endTime).format('HHmm'));

                if (
                    timeRangeStartTime <= thisStartTime && thisStartTime < timeRangeEndTime ||
                    timeRangeStartTime < thisEndTime && thisEndTime <= timeRangeEndTime
                ) {
                    this.valid = false;

                    return;
                }
            }
        }
    }
}
